import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";

import { SvgPoweredByFullscriptDark, SvgPoweredByFullscript } from "@shared/assets/logo";
import pureEncapsulationsLogoDark from "@shared/assets/referralPartners/pureEncapsulations/pure-encapsulations-logo-dark.webp";
import pureEncapsulationsLogo from "@shared/assets/referralPartners/pureEncapsulations/pure-encapsulations-logo.svg";
import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./ReferralPartnerSignUpBranding.styles";

interface Props {
  referralPartnerName: string;
}

// v1 uses bundled assets (pure encapsulations logo); will accept referralPartnerLogoUrl when multi-partner support lands.
const ReferralPartnerSignUpBranding = ({ referralPartnerName }: Props) => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";
  const PoweredByBadge = isDarkMode ? SvgPoweredByFullscriptDark : SvgPoweredByFullscript;

  return (
    <div css={styles.brandingRow} data-testid="referral-partner-sign-up-branding">
      <img
        src={isDarkMode ? pureEncapsulationsLogoDark : pureEncapsulationsLogo}
        alt={t(l.practitionerSignUp.referralPartner.logoAlt, { partnerName: referralPartnerName })}
        css={styles.partnerLogo}
        data-testid="partner-logo"
      />
      <PoweredByBadge
        css={styles.poweredByLogo}
        role="img"
        aria-label={t(l.practitionerSignUp.referralPartner.poweredByFullscript)}
      />
    </div>
  );
};

export { ReferralPartnerSignUpBranding };
